import * as Yup from 'yup';

import { Nullable } from '~globals/types/commons';
import { VALIDATIONS_ERROR } from '~constants/validationsError';
import { TemplateRoute } from '~services/templateRoute/types';
import {
  ApiTransactionItem,
  ApiTransactionVehicle,
} from '~services/apiTransaction/types';
import { WarehouseExtended } from '~services/warehouse/types';

import {
  getScheduleRouteBaseFormInititalValues,
  getScheduleRouteBaseValidationObject,
} from '../utils/scheduleRouteForm';
import {
  TABLE_KEY_FIELDS,
  DEFAULT_ORIGIN_ID,
  DEFAULT_DESTINY_ID,
} from '../utils/constants';
import { getDefaultScheduleStartDate } from '../utils/helpers';

export const FORM_BY_TEMPLATE_FIELDS_NAME = {
  SCHEDULE_NAME: 'scheduleName',
  SCHEDULE_START_DATE: 'scheduleStartDate',
} as const;

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const getFormByTemplateInitialValues = (defaultName?: string) => ({
  [FORM_BY_TEMPLATE_FIELDS_NAME.SCHEDULE_NAME]: defaultName ?? '',
  [FORM_BY_TEMPLATE_FIELDS_NAME.SCHEDULE_START_DATE]:
    getDefaultScheduleStartDate() as Nullable<Date>,
  ...getScheduleRouteBaseFormInititalValues(),
});

export const validationFormByTemplateSchema = Yup.object().shape({
  [FORM_BY_TEMPLATE_FIELDS_NAME.SCHEDULE_NAME]: Yup.string().required(),
  [FORM_BY_TEMPLATE_FIELDS_NAME.SCHEDULE_START_DATE]: Yup.date()
    .nullable()
    .typeError(VALIDATIONS_ERROR.INVALID_DATE)
    .required(VALIDATIONS_ERROR.REQUIRED),
  ...getScheduleRouteBaseValidationObject(
    FORM_BY_TEMPLATE_FIELDS_NAME.SCHEDULE_START_DATE,
  ),
});

export const getItemsBySelectedTemplate = (
  template: Nullable<TemplateRoute>,
): ApiTransactionItem[] => {
  if (!template) return [];

  return template.routeItems
    .sort((a, b) => a.order - b.order)
    .filter((routeItem) => Boolean(routeItem.item))
    .map((routeItem) => routeItem.item as ApiTransactionItem);
};

export const getItemsId = (
  items: ApiTransactionItem[],
): Array<string | number> => items.map((item) => item[TABLE_KEY_FIELDS.ORDER]);

export const getVehicleBySelectedTemplate = (
  template: Nullable<TemplateRoute>,
): Nullable<ApiTransactionVehicle> => {
  if (!template) return null;

  return template.vehicle;
};

export const getVehicleId = (
  vehicle: Nullable<ApiTransactionVehicle>,
): Nullable<string | number> => vehicle?.[TABLE_KEY_FIELDS.VEHICLE] ?? null;

export const getPointDescription = ({
  pointId,
  pointAddress,
  warehouses,
}: {
  pointId: Nullable<string>;
  pointAddress: Nullable<string>;
  warehouses: WarehouseExtended[];
}): string => {
  let description = 'Sin Especificar';

  if (pointId) {
    const isCustomPoint = [
      DEFAULT_ORIGIN_ID.toLowerCase(),
      DEFAULT_DESTINY_ID.toLowerCase(),
    ].includes(pointId);

    if (isCustomPoint && pointAddress) {
      description = pointAddress;
    }

    const currentWarehousePoint = warehouses.find(
      (warehouse) => warehouse.warehouseId === pointId,
    );

    if (currentWarehousePoint) {
      description = currentWarehousePoint.title;
    }
  }

  return description;
};
